import { isEmpty } from 'lodash';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import {
	SearchSuggestionsContainer,
	SearchSuggestionsList,
	SearchSuggestionsListItem,
	SearchSuggestionsListItemButton,
} from '../SearchSuggestions/styles';
import messages from './messages';
import {
	StyledLightningBoltIcon,
	StyledTimeIcon,
	TitleLineDelimiter,
	TrendingAndRecentsContainer,
	TrendingAndRecentsTitle,
} from './styles';

export function TrendingAndRecentResults({
	error,
	trendingTerms,
	recentSearches,
	title,
	onTermClick,
}: {
	error?: unknown;
	trendingTerms?: { term: string }[] | undefined;
	recentSearches?: string[];
	title: string;
	onTermClick: (term: string) => void;
}): ReactElement | null {
	const { formatMessage } = useIntl();

	if (error || (isEmpty(trendingTerms) && isEmpty(recentSearches))) return null; // Don't render if there are no trending terms or searches

	const handleTermClick = (result: string) => {
		onTermClick(result);
	};

	const results = trendingTerms ? trendingTerms.map(termObj => termObj.term) : recentSearches;

	return (
		<TrendingAndRecentsContainer>
			<TrendingAndRecentsTitle>
				{trendingTerms ? <StyledLightningBoltIcon /> : <StyledTimeIcon />}
				{formatMessage(messages[title as keyof typeof messages])}
			</TrendingAndRecentsTitle>
			<TitleLineDelimiter />
			<SearchSuggestionsContainer>
				<SearchSuggestionsList>
					{results?.map((result, index) => (
						<SearchSuggestionsListItem key={index}>
							<SearchSuggestionsListItemButton onClick={() => handleTermClick(result)}>
								{result}
							</SearchSuggestionsListItemButton>
						</SearchSuggestionsListItem>
					))}
				</SearchSuggestionsList>
			</SearchSuggestionsContainer>
		</TrendingAndRecentsContainer>
	);
}
